import apiClient, { jsonRequestConfig } from "./httpClient";
import endpoints from "./endpoints";

export const sensorsApi = {
  control: (payload, config = jsonRequestConfig) =>
    apiClient.post(endpoints.sensors.control(), payload, config),
  action: (actionType, device) => apiClient.get(endpoints.sensors.action(actionType, device)),
  streamUrl: (device) => endpoints.sensors.stream(device),
};

export default sensorsApi;
